import { AppRoutes } from "../../app/app-routes";
import { ResourceNotFoundGraphic } from "../../components/graphics/resource-not-found";
import { IBwjBillboardProps } from "../../framework/components/bwj-billboard";
import { BwjButtonType } from "../../framework/components/bwj-button";
import { useNavigator } from "../../framework/services/navigation";
import { xlate, xlationContext } from "../../framework/utils/i18n";

xlationContext('Standard resource not found view');

export const useStandardResourceNotFoundState = () => {
  const navigator = useNavigator();

  const props: IBwjBillboardProps = {
    graphic: ResourceNotFoundGraphic,
    message: xlate('Sorry - we could not find what you are looking for, or it is no longer available'),
    buttons: [{
      buttonStyle: BwjButtonType.PrimaryStandard,
      text: xlate('Go to My Discussion Plans'),
      onClick: () => navigator.goTo(AppRoutes.home.url()),
    }],
  };

  return props;
}